import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateNoCallFollowUps = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 428,
	height: 376,
	viewBox: "0 0 428 376",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M426.733 222.482L411.959 237.257C410.937 238.279 409.283 238.279 408.267 237.257C407.25 236.235 407.244 234.581 408.267 233.565L423.041 218.79C424.063 217.768 425.717 217.768 426.733 218.79C427.755 219.812 427.755 221.466 426.733 222.482Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M426.733 237.251C425.711 238.273 424.058 238.273 423.041 237.251L408.267 222.476C407.244 221.454 407.244 219.801 408.267 218.784C409.289 217.762 410.942 217.762 411.959 218.784L426.733 233.559C427.756 234.581 427.756 236.234 426.733 237.251Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M312.733 10.4813L297.959 25.2558C296.937 26.278 295.283 26.278 294.267 25.2558C293.25 24.2336 293.244 22.5802 294.267 21.5635L309.041 6.78911C310.063 5.76691 311.717 5.76691 312.733 6.78911C313.755 7.81131 313.755 9.46471 312.733 10.4813Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M312.733 25.2509C311.711 26.2731 310.058 26.2731 309.041 25.2509L294.267 10.4764C293.244 9.45424 293.244 7.80084 294.267 6.78423C295.289 5.76203 296.942 5.76203 297.959 6.78423L312.733 21.5587C313.756 22.5809 313.756 24.2343 312.733 25.2509Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8327 154.129L6.60477 174.357C5.20526 175.757 2.94156 175.757 1.5497 174.357C0.157833 172.958 0.150185 170.694 1.5497 169.302L21.7776 149.074C23.1772 147.675 25.4408 147.675 26.8327 149.074C28.2322 150.474 28.2322 152.737 26.8327 154.129Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8326 174.35C25.4331 175.75 23.1694 175.75 21.7776 174.35L1.54963 154.122C0.150122 152.723 0.150122 150.459 1.54963 149.067C2.94915 147.668 5.21284 147.668 6.60471 149.067L26.8326 169.295C28.2322 170.695 28.2322 172.958 26.8326 174.35Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.254 375.926C310.264 375.926 385.663 300.526 385.663 207.516C385.663 114.506 310.264 39.106 217.254 39.106C124.243 39.106 48.8438 114.506 48.8438 207.516C48.8438 300.526 124.243 375.926 217.254 375.926Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.764 41.0131C252.542 39.9353 258.926 44.5782 260.004 51.3561L295.053 272.683C296.131 279.461 291.488 285.845 284.711 286.923L114.819 313.827C108.041 314.904 101.657 310.262 100.579 303.484L65.5187 82.1569C64.4409 75.3791 69.0838 68.995 75.8617 67.9172L245.753 41.0131",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.764 41.0131C252.542 39.9353 258.926 44.5782 260.004 51.356L295.053 272.683C296.131 279.461 291.488 285.845 284.711 286.922L114.819 313.827C108.041 314.904 101.657 310.261 100.579 303.484L65.5187 82.1569C64.4409 75.3791 69.0838 68.995 75.8616 67.9172L245.753 41.0131M243.681 27.8927L73.7889 54.7968C59.7565 57.0146 50.1805 70.1972 52.3983 84.2296L87.4586 305.556C89.6764 319.589 102.859 329.165 116.891 326.947L286.783 300.043C300.816 297.825 310.392 284.642 308.174 270.61L273.124 49.2833C270.906 35.2509 257.723 25.6748 243.691 27.8927H243.681Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.183 32.8043L183.628 24.1809C201.071 21.4183 217.481 33.3413 220.244 50.7836L220.696 53.6394C221.205 56.8536 219.01 59.8874 215.786 60.3981L109.781 77.1876C106.567 77.6967 103.533 75.5015 103.022 72.2772L102.57 69.4213C99.8073 51.979 111.73 35.5685 129.173 32.8059L129.183 32.8043Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.343 3.11927C163.213 1.39751 173.434 8.82351 175.156 19.6942L176.889 30.6366L137.501 36.8751L135.768 25.9328C134.046 15.062 141.472 4.84102 152.343 3.11927Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.186 28.0376C159.215 28.0376 162.482 24.7711 162.482 20.7416C162.482 16.7121 159.215 13.4456 155.186 13.4456C151.156 13.4456 147.89 16.7121 147.89 20.7416C147.89 24.7711 151.156 28.0376 155.186 28.0376Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_9768_9376",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 102,
			y: 23,
			width: 119,
			height: 55,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M129.119 32.73L183.565 24.1067C201.007 21.3441 217.418 33.267 220.18 50.7093L220.633 53.5652C221.142 56.7793 218.947 59.8132 215.722 60.3239L109.717 77.1134C106.503 77.6225 103.469 75.4273 102.959 72.2029L102.506 69.3471C99.7438 51.9048 111.667 35.4942 129.109 32.7317L129.119 32.73Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_9768_9376)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M227.441 49.6303L95.2725 70.5637L97.2406 82.9903L229.409 62.0569L227.441 49.6303Z",
				fill: "#6BA6FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.765 41.0131C252.543 39.9353 258.927 44.5782 260.004 51.3561L295.054 272.683C296.132 279.461 291.489 285.845 284.711 286.923L114.82 313.827C108.042 314.904 101.658 310.262 100.58 303.484L65.5197 82.1569C64.4419 75.3791 69.0848 68.995 75.8626 67.9172L245.754 41.0131",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.765 41.0131C252.543 39.9353 258.927 44.5782 260.005 51.356L295.054 272.683C296.132 279.461 291.489 285.845 284.711 286.922L114.82 313.827C108.042 314.904 101.658 310.261 100.58 303.484L65.5197 82.1569C64.4419 75.3791 69.0848 68.995 75.8626 67.9172L245.754 41.0131M243.682 27.8927L73.7899 54.7968C59.7575 57.0146 50.1814 70.1972 52.3993 84.2296L87.4596 305.556C89.6774 319.589 102.86 329.165 116.892 326.947L286.784 300.043C300.817 297.825 310.393 284.642 308.175 270.61L273.125 49.2833C270.907 35.2509 257.724 25.6748 243.692 27.8927H243.682Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.184 32.8043L183.629 24.1809C201.072 21.4183 217.482 33.3413 220.245 50.7836L220.697 53.6394C221.206 56.8536 219.011 59.8874 215.787 60.3981L109.782 77.1876C106.568 77.6967 103.534 75.5015 103.023 72.2772L102.571 69.4213C99.8082 51.979 111.731 35.5685 129.173 32.8059L129.184 32.8043Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.343 3.11927C163.213 1.39751 173.434 8.82351 175.156 19.6942L176.889 30.6366L137.501 36.8751L135.768 25.9328C134.046 15.062 141.472 4.84102 152.343 3.11927Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.187 28.0376C159.216 28.0376 162.483 24.7711 162.483 20.7416C162.483 16.7121 159.216 13.4456 155.187 13.4456C151.157 13.4456 147.891 16.7121 147.891 20.7416C147.891 24.7711 151.157 28.0376 155.187 28.0376Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_9768_9376",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 102,
			y: 23,
			width: 119,
			height: 55,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M129.119 32.73L183.565 24.1067C201.007 21.3441 217.418 33.267 220.18 50.7093L220.633 53.5652C221.142 56.7793 218.947 59.8132 215.722 60.3239L109.717 77.1134C106.503 77.6225 103.469 75.4273 102.959 72.2029L102.506 69.3471C99.7438 51.9048 111.667 35.4942 129.109 32.7317L129.119 32.73Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_9768_9376)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M227.441 49.6303L95.2725 70.5637L97.2406 82.9903L229.409 62.0569L227.441 49.6303Z",
				fill: "#6BA6FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.625 139.256C151.444 139.441 150.668 140.6 150.952 141.759C153.969 153.991 165.895 162.102 178.576 160.134C191.267 158.178 200.176 146.842 199.367 134.271C199.291 133.079 198.197 132.216 197.017 132.391L152.625 139.245V139.256Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.491 150.558C189.441 146.94 183.046 145.213 176.422 146.241C169.809 147.268 164.223 150.843 160.495 155.816C165.545 159.435 171.94 161.162 178.565 160.134C185.189 159.107 190.764 155.532 194.491 150.558Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.466 111.206C150.875 107.369 147.279 104.746 143.453 105.336C139.616 105.926 136.993 109.523 137.583 113.349C138.173 117.185 141.77 119.809 145.596 119.219C149.432 118.628 152.056 115.032 151.466 111.206Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.511 102.953C202.92 99.1162 199.324 96.4926 195.498 97.0829C191.661 97.6732 189.038 101.27 189.628 105.096C190.218 108.932 193.815 111.556 197.641 110.966C201.477 110.375 204.101 106.779 203.511 102.953Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M291.312 231.767C323.937 231.767 350.385 205.319 350.385 172.694C350.385 140.069 323.937 113.621 291.312 113.621C258.687 113.621 232.239 140.069 232.239 172.694C232.239 205.319 258.687 231.767 291.312 231.767Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.595 175.181L284.638 191.224L318.444 157.418",
			stroke: "#EBF3FF",
			strokeWidth: 11,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEmptyStateNoCallFollowUps;
